import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/app/quizzes/$quizStateId/rounds/")(
  {
    component: RouteComponent,
  }
)

function RouteComponent() {
  return <div className="p-4">Quiz Rounds</div>
}
